import React, { useEffect } from 'react'
import {
  DeleteOutlined,
  MoreOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons'
import { Dropdown, Menu, message, Modal } from 'antd'
import { inject, observer } from 'mobx-react'
import InternalDocumentSignDetail from './InternalDocumentSignDetail'
import { useParams, useNavigate } from 'react-router-dom'

const { confirm } = Modal

const InternalDocumentSignDocDetailPage = ({
  loadingAnimationStore,
  history,
  fileStore,
  electronicDocumentStore,
  signedDocumentStore,
  notificationStore,
}) => {
  const { documentId } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    electronicDocumentStore
      .getElectronicDocumentById(documentId)
      .then(({ data }) =>
        fileStore.downloadAttachment(
          data.action_history.find(el => el.action === data.status).file_id
        )
      )
      .catch(err => {
        navigate('/internal-document/sign-document')
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      })
      .finally(() => loadingAnimationStore.showSpinner(false))

    return () => {
      electronicDocumentStore.clearSelectedElectronicDocument()
      electronicDocumentStore.clearCommentElectronicDocumentList()
      signedDocumentStore.clearDataPopupSign()
      signedDocumentStore.clearSignatureList()
      fileStore.clearDocumentAttachment()
      notificationStore.clearNotificationType()
    }
  }, [documentId])

  return <InternalDocumentSignDetail />
}

export default inject(
  'selectUserStore',
  'departmentStore',
  'loadingAnimationStore',
  'fileStore',
  'internalDocumentStore',
  'signedDocumentStore',
  'electronicDocumentStore',
  'notificationStore'
)(observer(InternalDocumentSignDocDetailPage))
